// LoginStepForgotPassword.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './LoginStepForgotPassword.css';

// Components
import Button from 'components/button/Button';
import TextInput from 'components/textinput/TextInput';
import WizardStep from 'components/wizard/WizardStep';
import WizardStepContent from 'components/wizard/WizardStepContent';
import LoginLabel from 'login/label/LoginLabel';

/**
 * LoginStepForgotPassword
 *
 * Wizard step for requesting a password reset email.
 *
 * @returns {ReactNode} The rendered component.
 */
const LoginStepForgotPassword = ({
  currentStep,
  direction,
  isAutoHeight,
  forgotEmail,
  forgotFormValid,
  forgotSent,
  handleForgotEmailChange,
  handleSendPasswordReset,
}) => {

  // ----- CONTEXT ----- //

  const { theme } = useTheme();

  // ----- RENDER ----- //

  return (
    <WizardStep
      step={3}
      currentStep={currentStep}
      direction={direction}
      isAutoHeight={isAutoHeight}
    >
      <WizardStepContent>
        <div className="login-form-container">

          {/* FORGOT INTRO */}
          <div className="login-forgot-intro">
            Enter the email for your account. We will send a link to reset your password.
          </div>

          {/* FORGOT GOOGLE HINT */}
          <div className="login-forgot-google-hint">
            If you originally signed in with Google, use Sign in with Google on the previous screen.
          </div>

          <div className="login-field-container">
            <LoginLabel text="Email Address" />
            <TextInput
              placeholder="Email Address..."
              value={forgotEmail}
              required={true}
              type="text"
              onChange={(e) => handleForgotEmailChange(e.target.value.trim().toLowerCase())}
              onEnterPress={handleSendPasswordReset}
            />
          </div>

          {/* FORGOT SENT */}
          {forgotSent && (
            <div className="login-forgot-sent">
              If an account exists for that email, we sent a reset link. Check your inbox and spam folder.
            </div>
          )}

          <div className="login-button-wrapper">
            <Button
              label={forgotSent ? 'Send Again...' : 'Send Reset Link...'}
              enabled={forgotFormValid}
              backgroundColor={theme.buttonHoverBackgroundColor}
              fontSize={14}
              height={44}
              onClick={handleSendPasswordReset}
            />
          </div>
        </div>
      </WizardStepContent>
    </WizardStep>
  );
};

// Dev Tools
LoginStepForgotPassword.displayName = 'LoginStepForgotPassword';

export default React.memo(LoginStepForgotPassword);
